<template>
    <v-dialog v-model="dialog" width="800px">
        <v-form ref="assignLeadForm">
            <v-card>
                <v-card-title class="justify-center">Set lead as not a duplicate</v-card-title>
                <v-divider></v-divider>
                <v-row no-gutters class="mx-5">
                    <v-col cols=2>Lead</v-col> 
                    <v-col cols=10>{{ lead.pten_code }}</v-col> 
                </v-row>
                <v-row no-gutters class="mx-5" v-if="lead.pten_bedrijfsnaam!==''">
                    <v-col cols=2>Company</v-col> 
                    <v-col cols=10>{{ lead.pten_bedrijfsnaam }}</v-col> 
                </v-row>
                <v-row no-gutters class="mx-5">
                    <v-col cols=2>Name</v-col> 
                    <v-col cols=10>{{ lead.pten_voornaam }} {{ lead.pten_naam }}</v-col> 
                </v-row>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" small @click="setToAssign">Confirm</v-btn>
                    <v-btn color="primary" small @click="closeLead">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-form> 
    </v-dialog>
</template>

<script>
    export default {
        components: {
        },
        props: {
        },
        data() {
            return {
                dialog: false,
                lead: {},
            }
        },
        methods: { 
            openDialog(lead) {
                this.lead = lead;
                this.dialog = true;
            },
            setToAssign() {
                this.$axios.post("ares/json/ares/pten/setPtenStatus.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "setPtenStatus",
                    },
                    setPtenAgent: {
                        pten_encrid: this.lead.pten_encrid,
                        ptst_code: "012-NewAssign",
                    },
                }).then((res) => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.setPtenStatus.text,
                            color: res.data.setPtenStatus.color,
                        });
                        this.$emit("actionClick", "refresh");
                        this.dialog = false;
                    }
                });
            },
            closeLead() {
                this.dialog = false;
            },
        }
    }
</script>

